// extracted by mini-css-extract-plugin
export var container = "TrustStripModule-module--container--bf7a0";
export var description = "TrustStripModule-module--description--2f223";
export var divider = "TrustStripModule-module--divider--7d341";
export var headline = "TrustStripModule-module--headline--b30b5";
export var hideDividerOnWrap = "TrustStripModule-module--hideDividerOnWrap--62c28";
export var icon = "TrustStripModule-module--icon--ada84";
export var item = "TrustStripModule-module--item--f3921";
export var pair = "TrustStripModule-module--pair--ab670";
export var pairDivider = "TrustStripModule-module--pairDivider--656aa";
export var textBlock = "TrustStripModule-module--textBlock--d3815";
export var threeItems = "TrustStripModule-module--threeItems--d580a";
export var wide = "TrustStripModule-module--wide--63588";
export var wideContent = "TrustStripModule-module--wideContent--21ac9";